import { Spacing, Stack, styled, Typography } from 'ui';

export const StyledAvatarContainer = styled(Stack)`
  padding: ${({ theme }) => theme.spacing(Spacing.Large)};
  gap: ${({ theme }) => theme.spacing(Spacing.Medium)};
  align-items: center;
  flex-direction: row;
  width: 100%;
`;

export const StyledTypography = styled(Typography)`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

export const StyledTextStack = styled(Stack)`
  flex: 1;
  min-width: 0;
`;
